function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// page-load
(function (window, factory) {
  // universal module definition
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./core'));
  } else {
    // browser global
    factory(window, window.InfiniteScroll);
  }
})(window, function factory(window, InfiniteScroll) {
  var proto = InfiniteScroll.prototype;
  Object.assign(InfiniteScroll.defaults, {
    // append: false,
    loadOnScroll: true,
    checkLastPage: true,
    responseBody: 'text',
    domParseResponse: true // prefill: false,
    // outlayer: null,

  });

  InfiniteScroll.create.pageLoad = function () {
    this.canLoad = true;
    this.on('scrollThreshold', this.onScrollThresholdLoad);
    this.on('load', this.checkLastPage);

    if (this.options.outlayer) {
      this.on('append', this.onAppendOutlayer);
    }
  };

  proto.onScrollThresholdLoad = function () {
    if (this.options.loadOnScroll) this.loadNextPage();
  };

  var domParser = new DOMParser();

  proto.loadNextPage = function () {
    var _this = this;

    if (this.isLoading || !this.canLoad) return;
    var _this$options = this.options,
        responseBody = _this$options.responseBody,
        domParseResponse = _this$options.domParseResponse,
        fetchOptions = _this$options.fetchOptions;
    var path = this.getAbsolutePath();
    this.isLoading = true;
    if (typeof fetchOptions == 'function') fetchOptions = fetchOptions();
    var fetchPromise = fetch(path, fetchOptions).then(function (response) {
      if (!response.ok) {
        var error = new Error(response.statusText);

        _this.onPageError(error, path, response);

        return {
          response: response
        };
      }

      return response[responseBody]().then(function (body) {
        var canDomParse = responseBody == 'text' && domParseResponse;

        if (canDomParse) {
          body = domParser.parseFromString(body, 'text/html');
        }

        if (response.status == 204) {
          _this.lastPageReached(body, path);

          return {
            body: body,
            response: response
          };
        } else {
          return _this.onPageLoad(body, path, response);
        }
      });
    })["catch"](function (error) {
      _this.onPageError(error, path);
    });
    this.dispatchEvent('request', null, [path, fetchPromise]);
    return fetchPromise;
  };

  proto.onPageLoad = function (body, path, response) {
    // done loading if not appending
    if (!this.options.append) {
      this.isLoading = false;
    }

    this.pageIndex++;
    this.loadCount++;
    this.dispatchEvent('load', null, [body, path, response]);
    return this.appendNextPage(body, path, response);
  };

  proto.appendNextPage = function (body, path, response) {
    var _this2 = this;

    var _this$options2 = this.options,
        append = _this$options2.append,
        responseBody = _this$options2.responseBody,
        domParseResponse = _this$options2.domParseResponse; // do not append json

    var isDocument = responseBody == 'text' && domParseResponse;
    if (!isDocument || !append) return {
      body: body,
      response: response
    };
    var items = body.querySelectorAll(append);
    var promiseValue = {
      body: body,
      response: response,
      items: items
    }; // last page hit if no items. #840

    if (!items || !items.length) {
      this.lastPageReached(body, path);
      return promiseValue;
    }

    var fragment = getItemsFragment(items);

    var appendReady = function appendReady() {
      _this2.appendItems(items, fragment);

      _this2.isLoading = false;

      _this2.dispatchEvent('append', null, [body, path, items, response]);

      return promiseValue;
    }; // TODO add hook for option to trigger appendReady


    if (this.options.outlayer) {
      return this.appendOutlayerItems(fragment, appendReady);
    } else {
      return appendReady();
    }
  };

  proto.appendItems = function (items, fragment) {
    if (!items || !items.length) return; // get fragment if not provided

    fragment = fragment || getItemsFragment(items);
    refreshScripts(fragment);
    this.element.appendChild(fragment);
  };

  function getItemsFragment(items) {
    // add items to fragment
    var fragment = document.createDocumentFragment();
    if (items) fragment.append.apply(fragment, _toConsumableArray(items));
    return fragment;
  } // replace <script>s with copies so they load
  // <script>s added by InfiniteScroll will not load
  // similar to https://stackoverflow.com/questions/610995


  function refreshScripts(fragment) {
    var scripts = fragment.querySelectorAll('script');

    var _iterator = _createForOfIteratorHelper(scripts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var script = _step.value;
        var freshScript = document.createElement('script'); // copy attributes

        var attrs = script.attributes;

        var _iterator2 = _createForOfIteratorHelper(attrs),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var attr = _step2.value;
            freshScript.setAttribute(attr.name, attr.value);
          } // copy inner script code. #718, #782

        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        freshScript.innerHTML = script.innerHTML;
        script.parentNode.replaceChild(freshScript, script);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } // ----- outlayer ----- //


  proto.appendOutlayerItems = function (fragment, appendReady) {
    var imagesLoaded = InfiniteScroll.imagesLoaded || window.imagesLoaded;

    if (!imagesLoaded) {
      console.error('[InfiniteScroll] imagesLoaded required for outlayer option');
      this.isLoading = false;
      return;
    } // append once images loaded


    return new Promise(function (resolve) {
      imagesLoaded(fragment, function () {
        var bodyResponse = appendReady();
        resolve(bodyResponse);
      });
    });
  };

  proto.onAppendOutlayer = function (response, path, items) {
    this.options.outlayer.appended(items);
  }; // ----- checkLastPage ----- //
  // check response for next element


  proto.checkLastPage = function (body, path) {
    var _this$options3 = this.options,
        checkLastPage = _this$options3.checkLastPage,
        pathOpt = _this$options3.path;
    if (!checkLastPage) return; // if path is function, check if next path is truthy

    if (typeof pathOpt == 'function') {
      var nextPath = this.getPath();

      if (!nextPath) {
        this.lastPageReached(body, path);
        return;
      }
    } // get selector from checkLastPage or path option


    var selector;

    if (typeof checkLastPage == 'string') {
      selector = checkLastPage;
    } else if (this.isPathSelector) {
      // path option is selector string
      selector = pathOpt;
    } // check last page for selector
    // bail if no selector or not document response


    if (!selector || !body.querySelector) return; // check if response has selector

    var nextElem = body.querySelector(selector);
    if (!nextElem) this.lastPageReached(body, path);
  };

  proto.lastPageReached = function (body, path) {
    this.canLoad = false;
    this.dispatchEvent('last', null, [body, path]);
  }; // ----- error ----- //


  proto.onPageError = function (error, path, response) {
    this.isLoading = false;
    this.canLoad = false;
    this.dispatchEvent('error', null, [error, path, response]);
    return error;
  }; // -------------------------- prefill -------------------------- //


  InfiniteScroll.create.prefill = function () {
    if (!this.options.prefill) return;
    var append = this.options.append;

    if (!append) {
      console.error("append option required for prefill. Set as :".concat(append));
      return;
    }

    this.updateMeasurements();
    this.updateScroller();
    this.isPrefilling = true;
    this.on('append', this.prefill);
    this.once('error', this.stopPrefill);
    this.once('last', this.stopPrefill);
    this.prefill();
  };

  proto.prefill = function () {
    var distance = this.getPrefillDistance();
    this.isPrefilling = distance >= 0;

    if (this.isPrefilling) {
      this.log('prefill');
      this.loadNextPage();
    } else {
      this.stopPrefill();
    }
  };

  proto.getPrefillDistance = function () {
    // element scroll
    if (this.options.elementScroll) {
      return this.scroller.clientHeight - this.scroller.scrollHeight;
    } // window


    return this.windowHeight - this.element.clientHeight;
  };

  proto.stopPrefill = function () {
    this.log('stopPrefill');
    this.off('append', this.prefill);
  }; // --------------------------  -------------------------- //


  return InfiniteScroll;
});